import React, { Fragment, useState } from "react";
import classes from "./InputWrapper.module.css";
import Modal from "./Modal"

const InputWrapper = ({
  title,
  desc_text,
  extra_text,
  help_text,
  error_text,
  msg_text,
  mode,
  children,
}) => {
  let className = classes.input_wrapper;
  if (mode) {
    className += ` ${classes[`${mode}_input`]}`;
  }
  const [showModal, setShowModal] = useState(false);
  const modalHandler = () => {
    setShowModal(!showModal);
  };

  return (
    <section className={className}>
      {showModal && (
        <Modal 
        modalHandler={modalHandler}
        allowClose = {true}
        buttonText = {'Close'}
        >
          <h1>
            {title}
          </h1>
          <p>
            {help_text}
          </p>
        </Modal>
      )}
      <div className={classes.header}>
        <div className={classes.text_box}>
          {title && <h3>{title}</h3>}
          {desc_text && <p><b>{desc_text}</b></p>}
          {extra_text && <p>{extra_text}</p>}
        </div>
        {help_text && <button className={classes.help_button} onClick={modalHandler} type="button">Help</button>}
      </div>
      <Fragment>{children}</Fragment>
      {error_text && (
        <div className={classes.error_msg}>
          <p>Error: {error_text}</p>
        </div>
      )}
      {msg_text && (
        <div className={classes.warning_msg}>
          <p>Warning: {msg_text}</p>
        </div>
      )}
    </section>
  );
};

export default InputWrapper;
